<bic-popup (close)="close()" [hasBackdrop]="true" [title]='isExistingRole ? "Benutzerdefinierte Berechtigung bearbeiten" : "Benutzerdefinierte Berechtigung erstellen"' customClass="w-[560px] h-fit">
  <div bicPopupContent class="flex flex-col">
    <form [formGroup]="form">
      <bic-input [formControlName]="'roleTitle'" [formGroup]="form" [label]="'Name der Rolle'" [placeholder]="'Name eingeben'" [maxLength] = 25
                 [required]="true"></bic-input>
    </form>
    <hr class="border-gray-100">
    <div class = "pt-4">
      @for (privilege of allPrivileges; track privilege) {
        <div (click)="selectPrivilege(privilege); $event.stopPropagation()" class="flex items-center px-3 pb-2 last:pb-0">
          <input [checked]="isSelected(privilege)"
                 class="w-4 h-4 !text-green bg-gray-50 rounded focus:ring-[none] border border-gray-300"
                 type="checkbox"
                 value="">
          <label class="text-sm pl-3 font-normal text-gray-900">{{ privilege.name | roleAndPrivileges }}</label>
        </div>
      }
    </div>
  </div>
  <div bicPopupButtonGroup class="flex flex-row w-full justify-end items-center gap-4">
    <bic-button buttonType="white" (onClick)="close()">Abbrechen</bic-button>
    @if (isExistingRole) {
      <bic-button
        buttonType="white"
        (onClick)="callDelete()"
        [disabled]="isAssigned"
        [tooltip]="isAssigned ? 'Berechtigung ist zugewiesen und kann nicht gelöscht werden' : null">
        Löschen
      </bic-button>
    }
    <bic-button (click)="saveChanges()" [disabled]="!checkInputFilled()">{{ isExistingRole ? 'Speichern' : 'Erstellen' }}</bic-button>
  </div>
</bic-popup>
